import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import { MatPaginatorIntl } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Environment } from '../../../../environments/enviroment.model';
import { BackendService } from '../../../core/backend.service';
import { EnvironmentProvider } from '../../../core/browser-providers';
import { TranslateService } from '../../../core/translate.service';
import { ActualizacionPrecio } from '../../../productos/modificacion-precio/actualizacion-precio.model';
import { SecurityService } from '../../../security/security.service';
import { DialogService } from '../../../shared-components/modals/dialog.service';
import { SearchInputComponent } from '../../../shared-components/search-input/search-input.component';
import { MediaService } from '../../../shared-services/media.service';
import { SnackService } from '../../../shared-services/snack.service';
import { UpdateEventService } from '../../../shared-services/update-event.service';
import { CodigoPromocion } from '../codigo-promocion.model';

interface Filters {
  name: string;
  page: number;
  size: number;
  email?: string;
  search?: string;
}

interface Page {
  pageIndex: number;
  pageSize: number;
}

@Component({
  selector: 'app-codigos-promocion-list',
  templateUrl: './codigos-promocion-list.component.html',
  styleUrls: ['./codigos-promocion-list.component.scss']
})
export class CodigosPromocionListComponent implements OnInit {

  public totalItems: number;
  isLoading = false;
  private backendUrl: string;
  notificacionFiltersActive = false;

  public limiteMaxFecha = "3000-06-09T00:00:00";

  

  private filters: Filters = {
    name: undefined,
    page: 0,
    size: 10,
  };

  @ViewChild(SearchInputComponent)
  private searchComponent: SearchInputComponent;

  codigosList: CodigoPromocion[] = [];

  //private getNewPage = new Subject<Filters>();

  constructor(
    @Inject(EnvironmentProvider) env: Environment,
    private route: ActivatedRoute,
    private backendService: BackendService,
    private paginatorsLabels: MatPaginatorIntl,
    private snackService: SnackService,
    private traslateService: TranslateService,
    public router: Router,
    protected updateEventService: UpdateEventService,
    private mediaService: MediaService,
    private http: Http,
    public securityService: SecurityService,
    private dialogService: DialogService,
  ) { 
    this.backendUrl = env.endpoints.api + '/backend';
  }

  ngOnInit() {

    this.backendService.get(CodigoPromocion, "/new-productos/all-codigos-promocion", null).toPromise()
    .then((cod) =>{
      this.codigosList = cod as CodigoPromocion[];
    });
  }

  clearSearch() {
    this.searchComponent.searchBox.value = '';
  }


  onPageChange(page: Page) {
    this.filters.page = page.pageIndex;
    this.filters.size = page.pageSize;
  }

  addCodDesc() {
    this.router.navigate(['/codigos-promocion/agregar']);
  }

  async deleteCodigo(id:number){
    
    this.snackService.spinner(true);
    try {
      await this.backendService.delete('/new-productos/delete-codigo-descuento/'+ id);
      this.snackService.success('Código de descueto Eliminado');    
   } catch (ex) {
     this.snackService.error(ex.message);
   } finally {
    
     this.snackService.spinner(false);

     this.backendService.get(CodigoPromocion, "/new-productos/all-codigos-promocion", null).toPromise()
    .then((cod) =>{
      this.codigosList = cod as CodigoPromocion[];
    });
     
    
   }
    
  }

}



// WEBPACK FOOTER //
// ./src/app/pedido/codigos-promocion/codigos-promocion-list/codigos-promocion-list.component.ts